var billDialogId;
var bill = {
    sendBill: function ($scope, ngDialog, usSpinnerService, $http) {
        return function (contractId,clientId) {
            // id услуги
            let serviceBtn = event.target.parentNode.querySelector('.service-suspend') || null;
            if(serviceBtn) {
                $scope.serviceId = Number(serviceBtn.dataset.id);
            } else {
                $scope.serviceId = event.target.dataset.id;
            }

            // end
            $scope.contractId = contractId;
            $scope.clientId = clientId;
            $http
                .get(Routing.generate('app_service_service_getbilldatabyclientservice', {
                    contract: contractId,
                    client: clientId,
                    clientService: $scope.serviceId
                }))
                .success(function (data) {
                    if (data.success) {
                        $scope.billData = data;
                        billDialogId = ngDialog.open(
                            {
                                template: 'sendBill.html',
                                scope: $scope,
                                closeByDocument: true,
                                onOpenCallback: function() {
                                    $("#bill-date").datepicker({
                                        dateFormat: "dd.mm.yy",
                                        onSelect: function () {
                                            var dateArray = $(this).val().split('.');
                                            var date = moment(new Date(dateArray[2], dateArray[1] - 1, dateArray[0]));
                                            $scope.billData.date = $(this).val();
                                            var dayMonth = date.format("DD MMMM");
                                            $scope.billData.template = $scope.billData.template.replace(/(Большая просьба оплатить счёт до )(\d{2}\s[а-я]+)/g, function(match, line, date){
                                                return line + dayMonth;
                                            });
                                        }
                                    });
                                }
                            }
                        );
                    } else {
                        alert(data.error);
                    }
                });
        };
    },
    send: function ($scope, ngDialog, usSpinnerService, $http) {
        return function () {
            usSpinnerService.spin('bill-send');
            $scope.sendDisabled = true;
            $http.post(
                Routing.generate('app_service_service_sendbill', {contract: $scope.contractId,client:$scope.clientId}),
                {
                    'sum': $scope.billData.sum,
                    'template': $scope.billData.template,
                    'date': $scope.billData.date,
                    'clientServiceId': ($scope.serviceId || null),
                    'legalId': $scope.billData.legalSelect.id,
                })
                .then(
                    function (response) {
                        usSpinnerService.stop('bill-send');
                        if (response.data.success) {
                            alert('Счёт отправлен');
                            ngDialog.close(billDialogId);
                            $scope.sendDisabled = false;
                        } else if (response.data.error) {
                            alert('Ошибка при отправке. Счёт НЕ ОТПРАВЛЕН. ' + response.data.error);
                        } else {
                            alert('Ошибка при отправке. Счёт НЕ ОТПРАВЛЕН.');
                        }
                    }, function () {
                        alert('Ошибка при отправке. Счёт НЕ ОТПРАВЛЕН.');
                        ngDialog.close(billDialogId);
                        $scope.sendDisabled = false;
                    }
                );
        };
    },
    sendExisting: function ($scope, ngDialog, usSpinnerService, $http) {
        return function (billId) {
            usSpinnerService.spin('bill-send');
            $scope.sendDisabled = true;
            $http.post(
                Routing.generate('app_service_service_sendexistingbill', {bill: billId}),
                {})
                .then(
                    function (response) {
                        usSpinnerService.stop('bill-send');
                        if (response.data.success) {
                            alert('Счёт отправлен');
                            ngDialog.close(billDialogId);
                            $scope.sendDisabled = false;
                        } else if (response.data.error) {
                            alert('Ошибка при отправке. Счёт НЕ ОТПРАВЛЕН. ' + response.data.error);
                            ngDialog.close(billDialogId);
                            $scope.sendDisabled = false;
                        } else {
                            alert('Ошибка при отправке. Счёт НЕ ОТПРАВЛЕН.');
                            ngDialog.close(billDialogId);
                            $scope.sendDisabled = false;
                        }
                    }, function () {
                        alert('Ошибка при отправке. Счёт НЕ ОТПРАВЛЕН.');
                        ngDialog.close(billDialogId);
                        $scope.sendDisabled = false;
                    }
                );
        };
    }
};